export default __webpack_public_path__ + "static/media/blog8.55de0e12.png";